import type { AnnotationsTrackConfig } from '../../core/components/annotations/types/annotations-track-props.js';
import type {
  NumericalAnnotationsMarkerConfig,
  NumericalAnnotationsTrackConfig,
} from '../../core/components/annotations/types/numerical-annotations-config.js';
import type { XYChartData } from '../../xy-chart/types/xy-chart.js';
import { ANNOTATIONS_KEYS } from '../shared/utils/render-xy-annotations.js';

export { ANNOTATIONS_KEYS } from '../shared/utils/render-xy-annotations.js';

export const transformHistogramAnnotationsToXY = (
  tracks: AnnotationsTrackConfig[],
): XYChartData[] => {
  const data: XYChartData[] = [];

  tracks.forEach((track, trackIndex) => {
    const histogramTrack = track as NumericalAnnotationsTrackConfig;
    const trackId = `track-${trackIndex}`;

    track.markers.forEach((marker) => {
      const histogramMarker = marker as NumericalAnnotationsMarkerConfig;

      data.push({
        [ANNOTATIONS_KEYS.trackId]: trackId,
        [ANNOTATIONS_KEYS.trackLabel]: histogramTrack.label,
        [ANNOTATIONS_KEYS.trackColor]: histogramTrack.color,
        [ANNOTATIONS_KEYS.trackHidden]: histogramTrack.hidden,
        [ANNOTATIONS_KEYS.trackSymbol]: histogramTrack.symbol,
        [ANNOTATIONS_KEYS.trackIndicators]: histogramTrack.indicatorsDisplay,
        [ANNOTATIONS_KEYS.markerStart]: histogramMarker.start,
        [ANNOTATIONS_KEYS.markerEnd]: histogramMarker.end,
        [ANNOTATIONS_KEYS.markerTitle]: histogramMarker.title,
        [ANNOTATIONS_KEYS.markerDescription]: histogramMarker.description,
        [ANNOTATIONS_KEYS.markerColor]: histogramMarker.color,
        [ANNOTATIONS_KEYS.markerHidden]: histogramMarker.hidden,
        [ANNOTATIONS_KEYS.markerSymbol]: histogramMarker.symbol,
        [ANNOTATIONS_KEYS.markerIndicators]: histogramMarker.indicatorsDisplay,
        [ANNOTATIONS_KEYS.markerPriority]: histogramMarker.priority,
      });
    });
  });

  return data;
};
